<template>
  <div>
    <div v-if="show" @click="show = false"
    class="detail_main z-index3"
    :class="{'popBg': show}">
    </div>
    <section v-if="show" class="mb-40 contact z-index3 width-70">
      <div  class="has-background-primary has-text-white commercialContentTop
              mt-10 is-size-14px is-marginless">
          <p>Une question ?</p>
          <div v-if="getCommercial.telephone">
            <p> Contactez-moi au
              <a
                :href="`tel:${getCommercial.telephone}`"
                class="has-text-weight-bold has-text-white underline"
              >
                {{getCommercial.telephone}}</a>
            </p>
            <p>ou par email
            <p>
              <a :href="`mailto:${getCommercial.email}`"
              class="has-text-weight-bold has-text-white underline">
              {{getCommercial.email}}
              </a>
            </p>
          </div>
          <div v-else>
            <p>Contactez moi par mail
              <a :href="`mailto:${getCommercial.email}`"
                 class="has-text-weight-bold has-text-white underline">
                {{getCommercial.email}}
              </a>
            </p>
          </div>
        </div>
        <div class="commercialContentBottom media is-mobile has-background-white">
            <div class="media-left">
              <avatar
                :username="getCommercial.prenom + ' ' + getCommercial.nom"
                :size="40"
                background-color="#333B53"
                color="white"/>
            </div>
            <div class="media-content">
              <label class="has-text-weight-bold has-text-grid-1 is-size-14px">
                {{getCommercial.prenom + ' ' + getCommercial.nom.toUpperCase()}}
              </label>
              <p class="is-size-7 has-text-grid-1 has-text-default">
                Responsable de clientèle chez
                <strong class="has-text-default"> {{getSociete.nom}} </strong>
              </p>
            </div>
        </div>
    </section>
    <div class="contact z-index3">
      <div v-if="pShow">
        <a @click="show = !show"
          class="is-marginless is-paddingless pastille
          level-right is-danger button is-rounded">
          <p class="is-size-7 mr-5">1</p>
        </a>
      </div>
      <a :href="`tel:${getCommercial.telephone}`" v-if="show"
       class="button is-primary is-rounded is-size-14px has-text-weight-bold">
        <b-icon v-if="show"
          icon="phone"
          size=""
        ></b-icon>
      </a>
      <a :href="`mailto:${getCommercial.email}`" v-if="show"
          class="button is-primary is-rounded is-size-14px has-text-weight-bold">
        <b-icon v-if="show"
          icon="email"
          size=""
        ></b-icon>
      </a>
      <a @click="show = !show ; pShow = false"
          class="level-right button is-primary is-rounded is-size-14px has-text-weight-bold">
          Contact
      </a>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Avatar from 'vue-avatar';

const Recommandation = createNamespacedHelpers('recommandation');
export default {
  components: {
    Avatar,
  },
  data: () => ({
      show: false,
      pShow: true,
  }),
  computed: {
    ...Recommandation.mapGetters({
      getCommercial: 'commercial',
      getSociete: 'societe',
    }),
  },
};
</script>

<style>

</style>
